import { VFC } from 'react'
import { ActionsMenu, DropdownMenu } from '@opallabs/lapidary'
import { SubMenu } from './SubMenu'
import type { Action, ContentCardOptionsMenuProps } from './types'

type ActionRendererProps = {
  action: Action
  parentProps: ContentCardOptionsMenuProps
}

export const ActionRenderer: VFC<ActionRendererProps> = ({
  action,
  parentProps,
}) => {
  const { handleAction } = parentProps

  if (action.type === 'separator') {
    return <DropdownMenu.Separator />
  }
  if (action.type === 'submenu') {
    return (
      <SubMenu
        actions={action.items}
        disabled={action.disabled}
        parentProps={parentProps}
        triggerLabel={action.label}
      />
    )
  }
  if (action.component !== undefined) {
    return <action.component label={action.label} {...parentProps} />
  }
  return (
    <ActionsMenu.Item
      destructive={action.destructive}
      disabled={action.disabled}
      onSelect={() => handleAction(action.actionType)}
    >
      {action.label}
    </ActionsMenu.Item>
  )
}
